export default __webpack_public_path__ + "static/14-02939b85242a86675d2fe5ebfdd245e6.jpg";